<template>
  <div class="flex size-full flex-col px-3 text-gray-700 md:p-0">
    <p class="text-left text-xl md:text-2xl">
      <span class="">¿Cuándo abrió </span>
      <span class="font-serif">tu tienda?</span>
    </p>
    <form
      class="flex w-full flex-col"
      @submit.prevent="onSubmit"
    >
      <div class="mt-5 grid w-full grid-cols-2 gap-3 md:mt-8">
        <button
          v-for="option in shopSinceOptions"
          :key="option.id"
          type="button"
          class="flex items-center rounded-md border border-gray-300 p-3"
          :class="{ 'border-gray-700': option.id === selectedShopSinceOption.id }"
          @click="(selectedShopSinceOption = option)"
        >
          <div
            class="w-full rounded-md text-left text-sm font-light text-gray-700 md:text-base"
            :class="{ 'font-normal': option.id === selectedShopSinceOption.id }"
          >
            {{ option.name }}
          </div>
        </button>
        <Field
          v-model="shopSinceOption"
          class="w-full border p-2"
          name="shopSince"
          hidden
          type="string"
          label="¿Cuándo abrió tu tienda?"
          :rules="{ required: true }"
        />
      </div>
      <div class="mt-5 flex w-full flex-col items-center md:mt-8">
        <button
          class="w-full rounded-md bg-gray-700 p-2 text-sm text-white md:text-base"
          :class="{ 'opacity-80': anyErrors, 'hover:bg-gray-800': !anyErrors }"
          :disabled="anyErrors"
        >
          Continuar
        </button>
        <a
          class="mt-1 cursor-pointer text-sm"
          @click="previousStep"
        >
          Volver
        </a>
        <ErrorMessage
          name="shopSince"
          class="text-xs text-red-500 md:text-sm"
        />
      </div>
    </form>
  </div>
</template>
<script lang="ts" setup>
import { ref, computed, watch, onMounted } from 'vue';
import { Field, ErrorMessage, useForm } from 'vee-validate';
import useSignUpStore from 'stores/sign-up-store';

const signUpStore = useSignUpStore();

interface ShopSinceOption {
  id: number;
  name: string;
  type: string;
  value: number;
}

const selectedShopSinceOption = ref({} as ShopSinceOption);
const shopSinceOption = computed(() => selectedShopSinceOption.value.name as string);
const shopSinceOptions = ref([
  { id: 0, name: 'Pronto a abrir', type: 'opening_soon', value: 0 },
  { id: 1, name: '2025', type: '2025', value: 2025 },
  { id: 2, name: '2024', type: '2024', value: 2024 },
  { id: 3, name: '2023', type: '2023', value: 2023 },
  { id: 4, name: '2022', type: '2022', value: 2022 },
  { id: 5, name: '2021', type: '2021', value: 2021 },
  { id: 6, name: '2020', type: '2020', value: 2020 },
  { id: 7, name: 'Antes del 2020', type: 'before_2020', value: 0 },
] as ShopSinceOption[]);

function previousStep() {
  signUpStore.currentStep = 'shop-category';
}

watch(selectedShopSinceOption, (newShopSince) => {
  signUpStore.shopForm.openedYearLabel = newShopSince.type;
  signUpStore.shopForm.openedYear = newShopSince.value;
});

onMounted(() => {
  const foundShopSince = shopSinceOptions.value.find((option) => option.type === signUpStore.shopForm.openedYearLabel);
  if (foundShopSince) selectedShopSinceOption.value = foundShopSince;
});

const anyErrors = computed(() => Object.keys(errors.value).length > 0);

const { handleSubmit, errors } = useForm();
const onSubmit = handleSubmit(() => {
  signUpStore.currentStep = 'shop-sales';
});
</script>
